import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Field } from '@tmap/mmm-style-guide/src/final-form/react';
import Question from './question';
import configToProps from './configToProps';

const SignatureField = styled(Field)(({ theme }) => ({
  alignItems: 'flex-start',
  '& .MuiFormControlLabel-label.MuiTypography-root.MuiTypography-body1': {
    marginLeft: theme.spacing(1),
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: 'normal',
    color: theme.palette.text.secondary,
    '&::before': {
      content: '"Ready to Submit"',
      color: theme.palette.text.disabled,
      display: 'block',
      fontSize: '18px',
      fontWeight: 400,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      paddingBottom: theme.spacing(1),
      marginTop: '1px',
      marginBottom: theme.spacing(1),
    },
  },
  '& .Mui-checked+.MuiFormControlLabel-label.MuiTypography-root.MuiTypography-body1': {
    '&::before': {
      color: theme.palette.text.primary,
    },
  },
  '&+.MuiFormHelperText-root.Mui-error': {
    display: 'none',
  },
}));

function MoreDetailsFormBody(props) {
  const {
    stage,
    incentive,
    fieldConfigs = [],
  } = props;
  const fields = fieldConfigs.filter((fc) => fc.category === stage);
  const confirmIndex = fields.findIndex((fc) => fc.path === 'user_list_item.app.appConfirm');
  const [confirmField] = fields.splice(confirmIndex);
  return (
    <Grid container spacing={4}>
      {fields.map((f) => <Question field={f} data={{ incentive }} key={f.path} titleSpacing='medium' />)}
      <Grid item xs={12}>
        <SignatureField {...configToProps(confirmField, { config: confirmField, ...incentive })} />
      </Grid>
    </Grid>
  );
}

export default MoreDetailsFormBody;
